import type { FillBoardsShow } from '@/types';
import { FillBars } from './components/FillBars';
import { Ph26Shell } from './components/Ph26Shell';

// /:event_slug/{mentor,track}-fill — the four one-line Next pages as one (PORTING.md G5).
// No <Head>: neither Next page declares metadata of its own, so the document title is the
// edition layout's and belongs to `sponsors-landing:pages`.
export default function Show({
  endpoint,
  title,
  emptyLabel,
  theme26,
}: FillBoardsShow) {
  return (
    <Ph26Shell enabled={theme26}>
      <FillBars endpoint={endpoint} title={title} emptyLabel={emptyLabel} />
    </Ph26Shell>
  );
}
